import { EarningsCallSummaryModal } from 'modules';



export const EarningsCallSummaryActivity = () => {
  return (
    <EarningsCallSummaryModal.FC />
  );
};
